import { createStore } from 'vuex'

export default createStore({
  state: {
    triggerServer: false //客服弹窗
  },
  getters: {
  },
  mutations: {
    toggleTriggerServer (state) {
      state.triggerServer = !state.triggerServer
      console.log(state.triggerServer)
    }
  },
  actions: {
  },
  modules: {
  }
})
